import { callApi, decryptText, encryptText } from "../utilservices";

interface Producer {
  id: number;
  codigoSAP: string;
  nombre: string;
  rut: string;
  correo: string | null;
  productorPadreId: number;
  codigoSAPPadre: string;
  nombrePadre: string;
  rutPadre: string;
  correoPadre: string | null;
  esPadre: boolean ;
}
//console.log('paso')
export const fetchProducers = async (
  pageNumber = 1,
  pageSize = 10,
  filtrarPor = "",
  textoBusqueda = ""
) => {
  const baseUrlenv = process.env.REACT_APP_API_URL;
  // Obtener seasonId directamente de los filtros almacenados
  const savedFilters = JSON.parse(decryptText(sessionStorage.getItem('filters') || '{}'));
  const idseason = savedFilters.seasonId || 6; // Usar 6 como fallback
  let url = `${baseUrlenv}Productor/${pageNumber}/${pageSize}`;
  
  console.log(filtrarPor,textoBusqueda)
  if (filtrarPor !== "" && textoBusqueda !== "") {
    url += `/${filtrarPor}/${textoBusqueda}`;
  } else {
    url += `/null/null`;
  }

  const perfilid = JSON.parse(decryptText(sessionStorage.getItem("data")!)).id;
  const perfil = JSON.parse(decryptText(sessionStorage.getItem("data")!)).perfilDescripcion;
  url +=`/${idseason}`;
  try {
    let productoresIds: number[] = [];

    // Si el perfil es "Productor", obtenemos los IDs de productores asociados al usuario
    if (perfil === "Productor") {
      const userResult = await callApi({
        url: `Usuarios/${perfilid}`, // Cambia esto a la ruta correcta para obtener el usuario
        method: "GET",
      });

      productoresIds = userResult.productores || [];
      pageSize = 2000;
      sessionStorage.setItem('prod', encryptText(JSON.stringify(productoresIds)));
      url = `${baseUrlenv}Productor/${pageNumber}/2000/`
      if (filtrarPor !== "" && textoBusqueda !== "") {
        url += `/${filtrarPor}/${textoBusqueda}`;
      } else {
        url += `/null/null`;
      }
      url +=`/${idseason}`;
    }
    else{
      sessionStorage.removeItem("prod");
    }

    // Hacemos la llamada a la API de productores
    const response = await callApi({
      url: url,
      method: "GET",
      responseType: "json",
    });

    // Extrae la lista de productores
    const allProducersList = response.lista || [];
   // console.log(allProducersList)
    // Aplica el filtro si el perfil es "Productor"
    const filteredProducersList =
      perfil === "Productor"
        ? allProducersList.filter((producer: Producer) =>
            productoresIds.includes(producer.productorPadreId) &&
            producer.esPadre
          )
        : allProducersList;
  
    // Mantén la estructura JSON original
    return {
      ...response,
      lista: filteredProducersList,
    };
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
